import React from "react";
import "./Data.css";
import TarjetaDeServicioData from "./components/TarjetaDeServicioData";
import GestionData from "./components/GestionData";
import { useTranslation } from "react-i18next";

interface ServiceItem {
  title: string;
  desc: string;
}

export default function Data() {
  const { t } = useTranslation();

  const services: ServiceItem[] = [
    {
      title: t("pages.data.services.0.title"),
      desc: t("pages.data.services.0.desc"),
    },
    {
      title: t("pages.data.services.1.title"),
      desc: t("pages.data.services.1.desc"),
    },
    {
      title: t("pages.data.services.2.title"),
      desc: t("pages.data.services.2.desc"),
    },
  ];

  return (
    <>
      <section
        className="fondo-data"
        style={{
          backgroundImage: 'url("/ImgData.webp")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        } as React.CSSProperties}
      >
        <div className="data-overlay">
          <h1 className="data-titulo">{t("pages.data.title")}</h1>
          <p className="data-descripcion">{t("pages.data.description")}</p>
        </div>
      </section>

      <h2 className="beneficios-title">{t("pages.data.benefits_title")}</h2>
      <div className="card-grid">
        {services.map((s, i) => {
          let animationClass = "";
          if (i === 0) animationClass = "from-left";
          else if (i === 1) animationClass = "from-bottom";
          else if (i === 2) animationClass = "from-right";
          return (
            <TarjetaDeServicioData
              key={s.title}
              service={s}
              animationClass={animationClass}
              delay={0}
            />
          );
        })}
      </div>
      <GestionData
        gestion={[
          {
            titulo: t("pages.data.gestion.0.titulo"),
            descripcion: t("pages.data.gestion.0.descripcion"),
          },
          {
            titulo: t("pages.data.gestion.1.titulo"),
            descripcion: t("pages.data.gestion.1.descripcion"),
          },
          {
            titulo: t("pages.data.gestion.2.titulo"),
            descripcion: t("pages.data.gestion.2.descripcion"),
          },
          {
            titulo: t("pages.data.gestion.3.titulo"),
            descripcion: t("pages.data.gestion.3.descripcion"),
          },
        ]}
        alcance={[
          { titulo: t("pages.data.alcance.0.titulo") },
          { titulo: t("pages.data.alcance.1.titulo") },
          { titulo: t("pages.data.alcance.2.titulo") },
          { titulo: t("pages.data.alcance.3.titulo") },
        ]}
      />
    </>
  );
}
